import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Printer } from "lucide-react";
import { api } from "../lib/api";
import { PageShell } from "../components/PageShell";
import { AppText, Button, Card } from "../components/ui";
import { Seo } from "../components/Seo";
import { FamilyBlock, VideoLibrary } from "../components/Gainage";

export default function Gainage() {
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  useEffect(() => { api.gainage().then(setData).catch((e) => setError(e.message)); }, []);

  return (
    <PageShell>
      <Seo title="Gainage vertical — la fiche" description="Les exercices de gainage vertical de la méthode Libère ta foulée : le Balai, le Pingouin, le 10/10/10… 10 à 12 min tous les jours, debout, jamais au sol." />
      <div className="print-sheet" data-testid="gainage-sheet">
        <div className="flex items-start justify-between gap-3 mt-4">
          <div>
            <AppText variant="display">Gainage vertical</AppText>
            <AppText variant="caption" className="text-km-muted mt-1">La fiche — même exercices, mêmes dosages que sur liberetafoulee.fr</AppText>
          </div>
          <Button title="Imprimer" size="md" variant="secondary" icon={<Printer size={16} strokeWidth={2.5} />} onClick={() => window.print()} testID="gainage-print" className="no-print shrink-0" />
        </div>
        {error ? <Card className="mt-6"><AppText variant="body" className="text-km-coral">{error}</AppText></Card> : null}
        {!data && !error ? <div className="py-24 flex justify-center"><span className="h-8 w-8 animate-spin rounded-full border-4 border-km-coral border-t-transparent" /></div> : null}
        {data ? (
          <>
            <Card className="mt-6 flex flex-col gap-2 print-family">
              <AppText variant="bodyStrong">Le principe</AppText>
              <AppText variant="body" className="text-km-ontertiary">{data.principle}</AppText>
              <AppText variant="body" className="text-km-ontertiary">{data.test}</AppText>
              <AppText variant="caption" className="text-km-muted">Ordre imposé des familles : {data.families.map((f) => `${f.num}. ${f.label.toLowerCase()}`).join(" → ")}.</AppText>
            </Card>
            <div className="flex flex-col gap-8 mt-8">
              {data.families.map((f, i) => (
                <React.Fragment key={f.key}>
                  <FamilyBlock family={f} />
                  {i === 0 ? <VideoLibrary lib={data.library} /> : null}
                </React.Fragment>
              ))}
            </div>
            <Card className="mt-8 flex flex-col gap-2 print-family" testID="gainage-consignes">
              <AppText variant="bodyStrong">À la sortie</AppText>
              <ul className="list-disc pl-5">{data.consignes.map((c) => <li key={c}><AppText variant="body" className="text-km-ontertiary">{c}</AppText></li>)}</ul>
              <AppText variant="label" className="text-km-coral mt-2">Signaux d'alerte — on arrête et on en parle</AppText>
              <ul className="list-disc pl-5">{data.alerts.map((c) => <li key={c}><AppText variant="body" className="text-km-ontertiary">{c}</AppText></li>)}</ul>
            </Card>
            <AppText variant="caption" className="text-km-muted mt-6">Source : {data.source}.</AppText>
            <div className="no-print mt-8 flex flex-col items-center gap-3">
              <Button title="Mon programme" onClick={() => navigate("/programme")} testID="gainage-to-program" />
              <button onClick={() => navigate("/methode")} className="min-h-[44px] font-text font-bold text-km-coral">← La méthode</button>
            </div>
          </>
        ) : null}
      </div>
    </PageShell>
  );
}
